import posthog from 'posthog-js'

export function usePostHog() {
  posthog.init('phc_gIbdXmrcUC5AMEQusjzyCFOybFvTcs1ZIfxfD0wFXFO', {
    api_host: 'https://eu.i.posthog.com',
    defaults: '2026-01-30'
  })

  return { posthog }
}
